<template>
    <div class="strategy_main" v-if="listBigCat5ExpansionSupplement != null" style="background-color: #303030">
        <div id="navigation_title" v-if="!isWeixinBrowser()" class="navigation" :style="{height:getNavCount()+'px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><img src="@/Images/icon_white_back.png"/></div>
            <div class="title">拓展补充</div>
            <div class="clear"></div>
        </div>

        <div v-if="!isWeixinBrowser()" :style="{'padding-top':getNavCount()+'px'}"></div>

        <div class="strategy_picture">
            <div class="group_img" v-for="(item,index) in listBigCat5ExpansionSupplement" :key="index">
                <div class="num">{{index + 1}}</div>
                <div class="title" v-html="item.text"></div>
                <img :src="$qiNiuDomainBase + item.picture" />
                <div class="group_text">长按保存图片</div>
            </div>
        </div>
        <div class="bottom"></div>

    </div>
</template>

<script>

    export default {
        data() {
            return {
                lessonId: 0,
                listBigCat5ExpansionSupplement: null,
            }
        },
        methods: {
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            goBack: function () {
                this.$router.go(-1);
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            showStatusWhite:function (status) {
                let that = this;

                if (that.isAppIos()) {
                    document.location = "readingclubapp:changeStatusStyle:" + status;
                }

                if (that.isAppAndroid()) {
                    window.note.changeStatusStyle(status);
                }
            },
            showStatusWhiteDelay(status) {
                let that = this;

                setTimeout(() => {
                    that.showStatusWhite(status);
                }, 200);
            },
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(this.$route.query.lessonId);
            let url = "bigCat/getExpansionSupplement/" + vLessonId;
            this.$axios.get(url).then((response) => {
                that.lessonId = vLessonId;
                that.listBigCat5ExpansionSupplement = response.data;

                if (!that.isWeixinBrowser()) {
                    that.$nextTick(() => {
                        $(window).scroll(function () {
                            var scrollTop = parseFloat(parseFloat($(window).scrollTop()));

                            if (scrollTop > 44) {
                                $("#navigation_title").removeClass("navigation");
                                $("#navigation_title").addClass("navigation_white");
                            } else {
                                $("#navigation_title").removeClass("navigation_white");
                                $("#navigation_title").addClass("navigation");
                            }
                        });
                    });
                }
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        activated() {
            window.scrollTo(0, 0);
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatusWhiteDelay(1);
            });
        },
        beforeRouteLeave(to, form, next) {
            this.showStatusWhite(0);
            next();
        },
    }
</script>

<style scoped>

    .left img {
        width: 30px;
        height: 30px;
        margin-top: 9px;
    }

    .strategy_main {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
        text-align: center;
    }

    .strategy_picture {
        position: relative;
        width: 100%;
        z-index: 997;
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    .group_img {
        width: 100%;
        height: auto;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 30px;
        z-index: 997;
        margin-bottom: 30px;
    }

    .group_text {
        margin-top: 3px;
        font-size: 10pt;
        color: white;
    }

    .video_lines .num, .group_img .num {
        background-color: #FEB800;
        color: white;
        font-size: 20px;font-weight: bold;
        display: inline-block;
        width: 35px;
        height: 35px;
        line-height: 35px;
        border-radius: 17.5px;
        -webkit-border-radius: 17.5px;
        -moz-border-radius: 17.5px;
    }

    .group_img img {
        width: 100%;
        height: auto;
        background-color: white;
    }

    .group_img .title {
        width: 100%;
        font-size: 15px;
        margin-top: -17.5px;
        margin-bottom: 15px;
        padding: 30px 15px 30px 15px;
        color: white;
        background-color: rgba(0,0,0,0.4);
        border-radius: 8px;
        text-align: left;
    }

    .bottom {
        height: 100px;
    }

</style>
